module.exports = __webpack_public_path__ + "static/media/biocertica-id-logo-default.c83a40c8.svg";